export const normalizeDirectoryItem = (fileData) => {
  if (!fileData) return fileData;

  const apiBaseUrl = process.env.REACT_APP_API_URL_LOGIN_AND_LOGOUT || "http://localhost:5000";

  const buildUrl = (path) => {
    if (!path || typeof path !== "string") return null;
    if (/^(http|https|blob):/.test(path)) return path;

    const safePath = path
      .replace(/\.\./g, "")
      .split("")
      .filter((ch) => {
        const code = ch.charCodeAt(0);
        if (code < 32) return false;
        return !'<>:"|?*'.includes(ch);
      })
      .join("")
      .replace(/^\/+/, "")
      .trim();

    return safePath ? `${apiBaseUrl}/${safePath}` : null;
  };

  const filePath = fileData.file_path || fileData.filePath;
  const thumbPath = fileData.thumbnail_path || fileData.thumbnailPath;
  const normalizedData = {
    ...fileData,
    dateModified:
      fileData.updated_at || fileData.dateModified || fileData.created_at,
    fileType: fileData.file_type || fileData.fileType,
    mimeType: fileData.mime_type || fileData.mimeType,
    filePath,
    file_path: filePath,
    thumbnailPath: thumbPath,
    thumbnail_path: thumbPath,
    fileUrl: fileData.fileUrl || buildUrl(filePath),
    thumbnailUrl: fileData.thumbnailUrl || buildUrl(thumbPath),
    parentId: fileData.parent_id || fileData.parentId,
    parent_id: fileData.parent_id || fileData.parentId,
    owner: fileData.owner,
    owner_id: fileData.owner_id,
    depth: fileData.depth,
    children: [],
  };
  // Recursively normalize children
  if (fileData.children && Array.isArray(fileData.children)) {
    normalizedData.children = fileData.children.map((child) =>
      normalizeDirectoryItem(child)
    );
  }
  return normalizedData;
};
